import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function combinedOrderForecastApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.CombinedorderforecastapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/jms/forwardPackage/forecast"
          },
          {
            key: "apiDocDesc.proUrl",
            value:
              "https://sop.jtfulfillment.cn/gateway/edi/jms/forwardPackage/forecast"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/jms/forwardPackage/forecast"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/jms/forwardPackage/forecast"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc493"
            },
            {
              name: "combinedOrderCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.combinedOrderCodeDesc494"
            },
            {
              name: "sourcePlatform",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.sourcePlatformDesc495"
            },
            {
              name: "packageList[]/packageCode",
              type: "ARRAY",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.packageCodeDesc496",
              children: [
                {
                  name: "packageCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.packageCodeDesc497"
                },
                {
                  name: "forwardPackageCode",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.forwardPackageCodeDesc498"
                },
                {
                  name: "base64EncodeContent",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.base64EncodeContentDesc499"
                }
              ]
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc500"
            },
            {
              name: "message",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.messageDesc501"
            },
            {
              name: "combinedOrderCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.combinedOrderCodeDesc502"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        combinedOrderCode: "202509061411",
        warehouseCode: "SH.001",
        sourcePlatform: "TT",
        packageList: [
          {
            packageCode: "202509061411",
            forwardPackageCode: "202509061411",
            base64EncodeContent: ""
          }
        ]
      },
      //返回示例
      responseCode: {
        success: "1",
        message: "创建成功"
      }
    }
  };
}
